module.exports = __webpack_public_path__ + "assets/6a227ec364f735ae68a43c9133878999.mp4";